angular.module('unergie.main')
.directive('salesTunnelPrm', ($q, DataAccess, AlertManager, BoFeaturesService, ModalService, ApiUser, ReferencesService,
MetaWatcher, AuthService, LandscapeQuestions, ErrorCatcher, OfferService) => ({
    restrict: 'E',
    scope: {
        draft: '=',
        landscape: '=',
        disableContractEdition: '=',
    },
    templateUrl: '/states/salesTunnelV2/component/salesTunnelPrm.html',
    link($scope) {
        $scope.saveDraft = MetaWatcher.notif.bind(null, 'SALES_TUNNEL.SAVE_DRAFT')
        $scope.savePrm = MetaWatcher.notif.bind(null, 'SALES_TUNNEL.SAVE_PRM')
        $scope.showTools = !BoFeaturesService.get('isEnvProd')
        $scope.prmMode = BoFeaturesService.isFeatureOn('sgeSearch')
        $scope.fetching = false
        $scope.redirectUrl = false
        $scope.prm = {
            id_prm: $scope.draft.id_prm,
            previous_id_prm: null,
            prmOk: null,
            prmResult: undefined,
            plan_id: undefined,
            id_p_calendar: undefined,
        }
        $scope.hints = []
        $scope.form = {
            choosen_id_p_calendar: $scope.draft.choosen_id_p_calendar,
            choosen_max_power: $scope.draft.choosen_max_power,
        }
        $scope.tools = {
            displayChoosen: false,
        }
        $scope.heatings = [
            { value: 'electric_heating', label: 'Chauffage éléctrique' },
            { value: 'collective_heating', label: 'Chauffage collectif' },
            { value: 'gas_heating', label: 'Chauffage au gaz' },
            { value: 'other', label: 'Autre' },
        ]

        let availablePowers = []
        $scope.powers = [{ id: null, label: '-- Choisissez --' }]
        $scope.calendarIds = [{ id: null, label: '-- Choisissez --' }]

        $scope.isAdmin = () => AuthService.userHasGroup(['data-admin', 'data-reader'])

        // VALIDATORS
        const initComponentValidator = () =>
            MetaWatcher.notif('SALES_TUNNEL.SET_VALIDATORS', {
                isPrmValid(store) {
                    return !!store.draft.id_prm && !(store.draft.prm_search_called && !store.draft.prm_search_hint)
                },
                isPrmEligible(store) {
                    return store.prm.prmResult && store.prm.prmResult.eligible
                },
                isMaxPowerDefined(store) {
                    return (!!store.draft.max_power || !!store.draft.choosen_max_power)
                },
                isIdPCalendarDefined(store) {
                    return (!!store.draft.id_p_calendar || !!store.draft.choosen_id_p_calendar)
                },
                isPrmSearchHintValid(store) {
                    if (store.draft.prm_search_called || store.draft.prm_search_hint) {
                        return !_.isNil(store.draft.prm_search_hint)
                    }
                    return true
                },
                isPrimaryResidenceDefined(store) {
                    return _.isBoolean(store.draft.primary_residence)
                },
                isHeatingDefined(store) {
                    return !_.isEmpty(store.draft.heating)
                },
            })


        // PRM Generator
        $scope.$on('prmSelected', (e, idPrm) => {
            $scope.prm = {
                id_prm: idPrm,
                previous_id_prm: $scope.prm.previous_id_prm,
                prmOk: null,
                eligible: false,
                prmResult: undefined,
                plan_id: undefined,
                id_p_calendar: undefined,
            }
            $scope.prmChanged()
            $scope.fetchPrm()
        })

        // Hints values
        ReferencesService.getRef('searchHints').then((mapping) => {
            $scope.hints = mapping
        })

        // TODO - Not required to update saveDraft on each keypress
        $scope.prmChanged = function () {
            $scope.savePrm($scope.prm)
            $scope.saveDraft({ id_prm: null, prm_search_called: false, prm_search_hint: null, heating: null, primary_residence: null })
        }

        // Choosen PRM data
        const initChoosenMaxPowerData = () => {
            if ($scope.draft.max_power === $scope.draft.choosen_max_power) {
                delete $scope.draft.choosen_max_power
            }
            $scope.powers = [{ id: null, label: $scope.draft.max_power ? `-- Pas de modification --` : '-- Choisissez --' }]
            const calendar = $scope.form.choosen_id_p_calendar ?
                availablePowers[$scope.form.choosen_id_p_calendar] :
                availablePowers[_.get($scope.prm, 'prmResult.plan') ? $scope.prm.prmResult.plan.id_p_calendar : undefined]
            if (calendar) {
                $scope.powers = $scope.powers.concat(calendar.availablePowers.map((p) => ({ id: p, label: `${p}kVA` })))
                if ($scope.draft.max_power) {
                    _.remove($scope.powers, { id: $scope.draft.max_power })
                }
                if (!_.find($scope.powers, { id: $scope.form.choosen_max_power })) {
                    $scope.form.choosen_max_power = $scope.powers[0].id
                }
            }
        }

        $scope.fetchPrm = function () {
            $scope.fetching = true
            let landscapeFlush
            if ($scope.prm.previous_id_prm && $scope.prm.id_prm !== $scope.prm.previous_id_prm) {
                landscapeFlush = LandscapeQuestions.flush({ id_contract: $scope.draft.id, draft: true }).$promise.then((result) => {
                    MetaWatcher.notif('SALES_TUNNEL.SAVE_LANDSCAPE', { landscapeDone: false, landscapeVersion: null })
                    return result
                })
            } else {
                landscapeFlush = $q.resolve()
            }
            landscapeFlush.then(() => {
                return ApiUser.eligibilityPRM({ id_prm: $scope.prm.id_prm, id_contract: $scope.draft.id }).$promise
            }).then((prm) => {
                $scope.prm = {
                    id_prm: $scope.prm.id_prm,
                    previous_id_prm: $scope.prm.id_prm,
                    prmOk: prm.eligible,
                    eligible: prm.eligible,
                    prmResult: prm.toJSON(),
                    plan_id: prm.eligible ? _.get(prm, 'plan.id') : undefined,
                    id_p_calendar: prm.eligible ? _.get(prm, 'plan.id_p_calendar') : undefined,
                    last_update: new Date().toISOString(),
                }

                // Notify other component on fetched prm, valid or not
                $scope.savePrm($scope.prm)
                $scope.saveDraftOnEligiblePrm(prm)
                initChoosenMaxPowerData()
            }).catch((error) => {
                ErrorCatcher(error)
                $scope.prm = {
                    id_prm: $scope.prm.id_prm,
                    previous_id_prm: $scope.prm.previous_id_prm,
                    prmOk: false,
                    eligible: false,
                    prmResult: error,
                    plan_id: undefined,
                    id_p_calendar: undefined,
                    last_update: new Date().toISOString(),
                }
                $scope.savePrm($scope.prm)
            }).finally(() => {
                $scope.fetching = false
            })
        }

        $scope.saveDraftOnEligiblePrm = function (prm) {
            if (prm.eligible) {
                // Notify draft changed
                $scope.saveDraft({
                    plan_id: (prm.plan != null ? prm.plan.id : undefined),
                    id_p_calendar: (prm.plan != null ? prm.plan.id_p_calendar : undefined),
                    plan: (prm.plan != null ? prm.plan.label : undefined),
                    meter_kind: prm.metter.kind,
                    routing_tariff: prm.routing_tariff,
                    max_power: (prm.power != null ? prm.power.max : undefined),
                    addr_city_code: prm.addr.city_code,
                    addr_city_lbl: prm.addr.city_lbl,
                    addr_details: prm.addr.details,
                    addr_num_street: prm.addr.num_street,
                    addr_post_code: prm.addr.post_code,
                    is_a_move: ['MES', 'MES_INTER', 'FIRST_MES'].includes(prm.subscriptionType),
                })
            } else {
                $scope.saveDraft({
                    plan_id: null,
                    id_p_calendar: null,
                    plan: null,
                    meter_kind: null,
                    routing_tariff: null,
                    max_power: null,
                    addr_city_code: null,
                    addr_city_lbl: null,
                    addr_details: null,
                    addr_num_street: null,
                    addr_post_code: null,
                    choosen_plan_id: null,
                    choosen_max_power: null,
                    choosen_id_p_calendar: null,
                })
            }
        }

        // Search PRM by postal address
        $scope.searchPrm = () =>
            ModalService.openModal({ type: 'prmSearchModal', size: 'xlg' }, { light: false }, (result) => {
                $scope.prm = {
                    id_prm: result,
                    previous_id_prm: $scope.prm.previous_id_prm,
                    prmOk: null,
                    eligible: false,
                    prmResult: undefined,
                    plan_id: undefined,
                    id_p_calendar: undefined,
                    last_update: new Date().toISOString(),
                }
                $scope.savePrm($scope.prm)
                $scope.updateSearchHint()
                if ($scope.prm.id_prm.length === 14) {
                    $scope.fetchPrm()
                }
            })


        $scope.updateSearchHint = function () {
            $scope.draft.prm_search_called = true
            $scope.saveDraft({ prm_search_called: $scope.draft.prm_search_called, prm_search_hint: $scope.draft.prm_search_hint })
        }

        // Initial data
        const initChoosenCalendarData = () =>
            ReferencesService.getRef('ot-ps').then((mapping) => {
                if ($scope.draft.id_p_calendar === $scope.draft.choosen_id_p_calendar) {
                    delete $scope.draft.choosen_id_p_calendar
                }
                availablePowers = mapping.toJSON()
                $scope.calendarIds = [{ id: null, label: $scope.draft.id_p_calendar ? '-- Pas de modification --' : '-- Choisissez --' }]
                .concat(_.map(availablePowers, (v, k) => ({ id: k, label: v.label })))
                if ($scope.draft.id_p_calendar) {
                    _.remove($scope.calendarIds, { id: $scope.draft.id_p_calendar })
                }
            })

        $scope.updateChoosenCalendarId = () => {
            initChoosenMaxPowerData()
            $scope.saveChoosenData()
            MetaWatcher.notif('SALES_TUNNEL.UPDATED_CHOOSEN_DATA', { choosen_id_p_calendar: $scope.form.choosen_id_p_calendar })
        }

        $scope.changeModifyOffer = () => {
            if (!$scope.form.modify_offer) {
                if ($scope.draft.id_p_calendar) {
                    $scope.form.choosen_id_p_calendar = null
                }
                if ($scope.draft.max_power) {
                    $scope.form.choosen_max_power = null
                }
                $scope.saveChoosenData()
            }
        }

        $scope.updateMaxPower = () => {
            $scope.saveChoosenData()
            MetaWatcher.notif('SALES_TUNNEL.UPDATED_CHOOSEN_DATA', { choosen_max_power: $scope.form.choosen_max_power })
        }

        $scope.saveChoosenData = function () {
            const id_p_calendar_modified = $scope.draft.id_p_calendar !== $scope.form.choosen_id_p_calendar
            const max_power_modified = $scope.draft.max_power !== $scope.form.choosen_max_power
            if (id_p_calendar_modified || max_power_modified) {
                $scope.saveDraft({
                    choosen_id_p_calendar: id_p_calendar_modified ? $scope.form.choosen_id_p_calendar : null,
                    choosen_max_power: max_power_modified ? $scope.form.choosen_max_power : null,
                })
            }
        }

        // PROVIDER OFFER
        const initAvailableRefProviderOffer = () => {
            OfferService.selectableOffersPromise.then((offersResult) => {
                $scope.offers = offersResult
            }).catch(ErrorCatcher)
        }

        $scope.getProviderOfferLabel = (provider_offer) => _.get(_.find($scope.offers, { value: provider_offer }), 'label')

        $scope.changeOfferFields = {}
        $scope.changeOfferPayload = {}

        $scope.prepareUpdateRefProviderOffer = () => {
            $scope.changeOfferFields = {
                provider_offer: {
                    label: 'Offre fournisseur',
                    required: true,
                    type: 'select',
                    enum: $scope.offers,
                },
            }

            $scope.changeOfferPayload = {
                provider_offer: $scope.form.provider_offer,
            }
        }

        $scope.updateRefProviderOffer = () => {
            return DataAccess.modifyDraftOffer({ id_contract: $scope.draft.id }, { provider_offer: $scope.changeOfferPayload.provider_offer }).$promise.then((result) => {
                MetaWatcher.notif('SALES_TUNNEL.RELOAD_DRAFT', {})
            }).catch(ErrorCatcher)
        }

        // PRM Form
        $scope.$watch('draft', (draft, previousDraft) => {
            $scope.form = {
                choosen_id_p_calendar: (draft.choosen_id_p_calendar !== draft.id_p_calendar) ? draft.choosen_id_p_calendar : null,
                choosen_max_power: (draft.choosen_max_power !== draft.max_power) ? draft.choosen_max_power : null,
                provider_offer: draft.provider_offer,
                modify_offer: $scope.form.modify_offer || !!(
                    (draft.choosen_id_p_calendar && draft.id_p_calendar && draft.choosen_id_p_calendar !== draft.id_p_calendar) ||
                    (draft.choosen_max_power && draft.max_power && draft.choosen_max_power !== draft.max_power)
                ),
                primary_residence: draft.primary_residence,
                heating: draft.heating,
            }

            if (draft.is_a_move !== previousDraft.is_a_move && _.get($scope, 'prm.id_prm.length') === 14) {
                $scope.fetchPrm()
            }
            initChoosenCalendarData()
            initChoosenMaxPowerData()
        })

        const activate = function () {
            initComponentValidator()
            initChoosenCalendarData()
            initAvailableRefProviderOffer()

            // Fetch prm on init
            if (!_.isEmpty($scope.draft.id_prm)) {
                $scope.fetchPrm()
            }
        }

        activate()
    },
}))
